import React from 'react'
import Faq from '../Components/Faq/Faq'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'

function FAQ() {
  return (
    <div>
        <Header/>
        <Faq/>
        <Footer/>
    </div>
  )
}

export default FAQ